<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: The root VueComponent of the site.
-->

<template>
  <div id="app">
    <navbar />
    <b-container fluid="">
      <b-row>
        <b-col
          cols="12"
          sm="3"
          lg="2"
          class="gh-sidebar p-4 rounded-bottom shadow"
        >
          <b-img
            src="/assets/img/media/gary-tab-256px.jpg"
            fluid
            class="rounded-lg mx-auto shadow"
            alt="Gary and Tabitha"
          />
          <b-nav vertical>
            <b-nav-item
              v-for="nav in navs"
              :key="nav.text"
              :active="activeNav === nav.to"
              :to="nav.to"
            >
              <font-awesome-icon
                v-show="nav.icon"
                :icon="nav.icon"
                class="fa-fw"
              />
              {{ nav.text }}
            </b-nav-item>
          </b-nav>
        </b-col>
        <b-col>
          <main class="p-4">
            <router-view />
          </main>
        </b-col>
      </b-row>
    </b-container>
    <footer class="footer border-top mx-auto text-center">
      Copyright, &copy; 2018-{{ new Date().getFullYear().toString() }}
    </footer>
  </div>
</template>

<script>
// The JSON+LD structured data definition.
import structuredData from './structured-data-gary.json'

// First-party imports.
import Navbar from '@/components/Navbar'

export default {
  name: 'App',

  components: {
    Navbar
  },

  data () {
    return {
      navs: [{
        text: 'Home',
        icon: 'home',
        to: '/'
      }, {
        text: 'My Publications',
        icon: 'scroll',
        to: '/publications'
      }, {
        text: 'My Projects',
        icon: 'tools',
        to: '/projects'
      }, {
        text: 'My Credentials',
        icon: 'award',
        to: '/credentials'
      }],
      structuredData: structuredData
    }
  },

  computed: {
    /**
     * The name of the currently active path.
     *
     * @returns {string}
     */
    activeNav () {
      return this.$route.path
    }
  },

  /**
   * Add the JSON+LD structured data to the head element.
   */
  mounted () {
    const structuredDataElement = document.createElement('script')
    structuredDataElement.id = 'structured-data'
    structuredDataElement.type = 'application/ld+json'
    structuredDataElement.text = JSON.stringify(this.structuredData, null, 2)
    document.querySelector('head').appendChild(structuredDataElement)
  }
}
</script>

<style scoped>
.gh-sidebar {
  background-color: rgba(200,204,208,.65);
  height: 100vh;
}

/* noinspection CssUnusedSymbol */
.gh-sidebar .nav .nav-link {
  display: block;
  padding: .25rem;
  color: rgba(49, 49, 49, .85);
}

/* noinspection CssUnusedSymbol */
.gh-sidebar .nav .nav-link:hover {
  font-weight: 600;
  color: rgba(58, 33, 105, .95);
  background-color: transparent;
}

/* noinspection CssUnusedSymbol */
.gh-sidebar .nav .nav-link.active:hover,
.gh-sidebar .nav .nav-link.active {
  font-weight: 600;
  color: rgba(58, 33, 105, .85);
  background-color: transparent;
}

.footer {
  margin-top: 2rem;
  margin-bottom: 3rem;
}
</style>
